import { stateName } from './constants';

const localState = state => state[stateName];

export const getCountries = state => {
  const {
    countries
  } = localState(state);
  return countries.ids.map(id => countries.byId[id]);
};
export const getCountryById = (state, id) => {
  if (id === null) return null;
  return localState(state).countries.byId[id] || null;
};
export const getCities = state => {
  const {
    cities
  } = localState(state);
  return cities.ids.map(id => cities.byId[id]);
};
export const getCityById = (state, id) => {
  if (id === null) return null;
  return localState(state).cities.byId[id] || null;
};